var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGreyCoins(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 60,
    viewBox: "0 0 61 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.1,
    x: 0.5,
    width: 60,
    height: 60,
    rx: 7,
    fill: "#085685"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.5 37.0312V39C18.5 40.6875 22.5312 42 27.5 42C32.4688 42 36.5 40.6875 36.5 39V37.0312C34.5312 38.3906 31.0156 39 27.5 39C23.9375 39 20.4219 38.3906 18.5 37.0312ZM33.5 24C38.4688 24 42.5 22.6875 42.5 21C42.5 19.3594 38.4688 18 33.5 18C28.5312 18 24.5 19.3594 24.5 21C24.5 22.6875 28.5312 24 33.5 24ZM18.5 32.1094V34.5C18.5 36.1875 22.5312 37.5 27.5 37.5C32.4688 37.5 36.5 36.1875 36.5 34.5V32.1094C34.5312 33.7031 31.0156 34.5 27.5 34.5C23.9375 34.5 20.4219 33.7031 18.5 32.1094ZM38 32.625C40.6719 32.1094 42.5 31.125 42.5 30V28.0312C41.375 28.7812 39.7812 29.2969 38 29.625V32.625ZM27.5 25.5C22.5312 25.5 18.5 27.1875 18.5 29.25C18.5 31.3594 22.5312 33 27.5 33C32.4688 33 36.5 31.3594 36.5 29.25C36.5 27.1875 32.4688 25.5 27.5 25.5ZM37.7656 28.1719C40.5781 27.6562 42.5 26.6719 42.5 25.5V23.5312C40.8125 24.7031 37.9531 25.3125 34.9531 25.5C36.3125 26.1562 37.3438 27.0469 37.7656 28.1719Z",
    fill: "#80AAC2"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreyCoins);
export default __webpack_public_path__ + "static/media/greyCoins.7eae8b1a.svg";
export { ForwardRef as ReactComponent };